import { useState } from 'react';
import { ProductGrid, POSCart } from '@/components/pos';
import { mockProducts } from '@/lib/mock-data';
import { useCart } from '@/contexts/CartContext';
import { toast } from 'sonner';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';

export default function POSPage() {
  const { addItem, itemCount } = useCart();
  const [mobileCartOpen, setMobileCartOpen] = useState(false);

  const handleAddToCart = (product) => {
    addItem(product, 1);
    toast.success(`${product.name} added to cart`);
  };

  const handleCheckout = (orderData) => {
    console.log('Order completed:', orderData);
    toast.success('Order completed successfully!');
  };

  return (
    <>
      <div className="h-[calc(100vh-7rem)] -m-4 lg:-m-6 flex" data-testid="pos-page">
        {/* Product Grid */}
        <div className="flex-1">
          <ProductGrid products={mockProducts} onAddToCart={handleAddToCart} />
        </div>

        {/* Cart */}
        <div className="w-96 shrink-0 hidden lg:block">
          <POSCart onCheckout={handleCheckout} />
        </div>
      </div>

      {/* Mobile Cart */}
      <Button
        type="button"
        className="fixed bottom-4 right-4 z-40 lg:hidden shadow-lg"
        onClick={() => setMobileCartOpen(true)}
      >
        <ShoppingCart className="h-4 w-4 mr-2" />
        Cart ({itemCount})
      </Button>

      <Sheet open={mobileCartOpen} onOpenChange={setMobileCartOpen}>
        <SheetContent side="right" className="w-full sm:w-[420px] p-0">
          <div className="h-full">
            <POSCart onCheckout={handleCheckout} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
